// Color Constants
export const COLORS = {
  primary: '#2563EB',
  darkNavy: '#0B1F3A',
  background: '#F8FAFC',
  cardBg: '#FFFFFF',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  textPrimary: '#0B1F3A',
  textSecondary: '#64748B',
  border: '#E2E8F0',
  emerald: '#16A34A',
  navy: '#0F172A',
  gold: '#F59E0B',
};

// User Roles
export const USER_ROLES = {
  STUDENT: 'student',
  TEACHER: 'teacher',
  ADMIN: 'admin',
  EDITOR: 'editor',
};

// Class Levels
export const CLASS_LEVELS = {
  JSS1: 'jss1',
  JSS2: 'jss2',
  JSS3: 'jss3',
  SS1: 'ss1',
  SS2: 'ss2',
  SS3: 'ss3',
  UTME: 'utme',
};

export const CLASS_NAMES = {
  jss1: 'Junior Secondary 1',
  jss2: 'Junior Secondary 2',
  jss3: 'Junior Secondary 3',
  JSS1: 'Junior Secondary 1',
  JSS2: 'Junior Secondary 2',
  JSS3: 'Junior Secondary 3',
  ss1: 'Senior Secondary 1',
  ss2: 'Senior Secondary 2',
  ss3: 'Senior Secondary 3',
  SS1: 'Senior Secondary 1',
  SS2: 'Senior Secondary 2',
  SS3: 'Senior Secondary 3',
  utme: 'UTME',
  UTME: 'UTME',
};

// Subscription Status
export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  CANCELLED: 'cancelled',
  PENDING: 'pending',
};

// Content Status
export const CONTENT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

// Payment Status
export const PAYMENT_STATUS = {
  SUCCESS: 'success',
  PENDING: 'pending',
  FAILED: 'failed',
};

// Firestore Collections
export const COLLECTIONS = {
  USERS: 'users',
  CLASSES: 'classes',
  SUBJECTS: 'subjects',
  SUBSCRIPTIONS: 'subscriptions',
  PAYMENTS: 'payments',
  CONTENT: 'content',
  CONTENT_APPROVAL: 'content_approvals',
  NOTIFICATIONS: 'notifications',
  PRICING: 'pricing',
  SYLLABUS: 'syllabus',
  QUIZZES: 'quizzes',
  LIBRARY_ITEMS: 'library_items',
};

// Notification Audiences
export const NOTIFICATION_AUDIENCES = {
  ALL_USERS: 'all_users',
  ALL_STUDENTS: 'all_students',
  SS1_STUDENTS: 'ss1_students',
  SS2_STUDENTS: 'ss2_students',
  SS3_STUDENTS: 'ss3_students',
  UTME_STUDENTS: 'utme_students',
  TEACHERS: 'teachers',
  SUBSCRIBED_ONLY: 'subscribed_only',
};

// Available Subjects by Class
export const AVAILABLE_SUBJECTS = {
  'JSS1': [
    'english_jss1',
    'math_jss1',
    'phe_jss1',
    'crs_jss1',
    'irs_jss1',
    'nigerian_history_jss1',
    'social_citizenship_jss1',
    'cca_jss1',
    'french_jss1',
    'intermediate_science_jss1',
    'digital_technologies_jss1',
    'business_studies_jss1',
    'trade_subjects_jss1',
  ],
  'JSS2': [
    'english_jss2',
    'math_jss2',
    'phe_jss2',
    'crs_jss2',
    'irs_jss2',
    'nigerian_history_jss2',
    'social_citizenship_jss2',
    'cca_jss2',
    'french_jss2',
    'intermediate_science_jss2',
    'digital_technologies_jss2',
    'business_studies_jss2',
    'trade_subjects_jss2',
  ],
  'JSS3': [
    'english_jss3',
    'math_jss3',
    'phe_jss3',
    'crs_jss3',
    'irs_jss3',
    'nigerian_history_jss3',
    'social_citizenship_jss3',
    'cca_jss3',
    'french_jss3',
    'intermediate_science_jss3',
    'digital_technologies_jss3',
    'business_studies_jss3',
    'trade_subjects_jss3',
  ],
  'SS1': [
    'english_ss1', 'math_ss1', 'physics_ss1', 'chem_ss1', 'bio_ss1', 
    'fmaths_ss1', 'agric_ss1', 'economics_ss1', 'accounting_ss1', 
    'fin_accounting_ss1', 'marketing_ss1', 'literature_ss1', 'govt_ss1'
  ],
  'SS2': [
    'english_ss2', 'math_ss2', 'physics_ss2', 'chem_ss2', 'bio_ss2', 
    'fmaths_ss2', 'agric_ss2', 'economics_ss2', 'accounting_ss2', 
    'fin_accounting_ss2', 'marketing_ss2', 'literature_ss2', 'govt_ss2'
  ],
  'SS3': [
    'english_ss3', 'math_ss3', 'physics_ss3', 'chem_ss3', 'bio_ss3', 
    'fmaths_ss3', 'agric_ss3', 'economics_ss3', 'accounting_ss3', 
    'fin_accounting_ss3', 'marketing_ss3', 'literature_ss3', 'govt_ss3'
  ],
  'UTME': [
    'math_utme', 'english_utme', 'physics_utme', 'chem_utme', 'bio_utme', 
    'fmaths_utme', 'economics_utme', 'govt_utme', 'literature_utme',
    'agric_utme', 'fin_accounting_utme', 'marketing_utme', 'commerce_utme',
    'digital_tech_utme', 'geography_utme'
  ],
};

export const ALL_AVAILABLE_SUBJECT_IDS = Object.values(AVAILABLE_SUBJECTS).flat();

export const SUBJECT_NAMES = {
  // Core & JSS Official Subjects
  'english': 'English Language', // dynamically 'English Studies' in JSS
  'english_studies': 'English Studies',
  'math': 'Mathematics',
  'mathematics': 'Mathematics',
  'phe': 'Physical and Health Education',
  'crs': 'Christian Religious Studies',
  'irs': 'Islamic Studies',
  'nigerian_history': 'Nigerian History',
  'social_citizenship': 'Social and Citizenship Studies',
  'cca': 'Cultural and Creative Arts (CCA)',
  'french': 'French',
  'intermediate_science': 'Intermediate Science',
  'digital_technologies': 'Digital Technologies',
  'business_studies': 'Business Studies',
  'trade_subjects': 'Trade Subjects',

  // Senior Subjects
  'physics': 'Physics',
  'chem': 'Chemistry',
  'bio': 'Biology',
  'fmaths': 'Further Maths',
  'agric': 'Agricultural Science',
  'economics': 'Economics',
  'accounting': 'Accounting',
  'fin_accounting': 'Financial Accounting',
  'marketing': 'Marketing',
  'literature': 'Literature in English',
  'govt': 'Government',
  'digital_tech': 'Digital Technology',
  'commerce': 'Commerce',
  'geography': 'Geography',

  // Legacy / Aliases
  'basic_science': 'Intermediate Science',
  'basic_tech': 'Basic Technology',
  'social_studies': 'Social and Citizenship Studies',
  'civic': 'Social and Citizenship Studies',
  'ict': 'Digital Technologies',
  'home_econ': 'Home Economics',
};

export const getSubjectClass = (subjectId) => {
  if (!subjectId) return 'ss1';
  const parts = subjectId.split('_');
  return parts.pop().toLowerCase();
};

export const getSubjectName = (subjectId) => {
  if (!subjectId) return '';
  const parts = subjectId.split('_');
  if (parts.length < 2) return SUBJECT_NAMES[subjectId] || subjectId;
  const level = parts[parts.length - 1].toLowerCase();
  const base = parts.slice(0, -1).join('_');
  if (base === 'english') {
    return level.startsWith('jss') ? 'English Studies' : 'English Language';
  }
  return SUBJECT_NAMES[base] || SUBJECT_NAMES[subjectId] || base;
};

export const formatSubject = (subjectId) => {
  if (!subjectId) return '';
  const parts = subjectId.split('_');
  if (parts.length < 2) return subjectId;
  const level = parts.pop().toUpperCase();
  const base = parts.join('_');
  let name = SUBJECT_NAMES[base] || base;
  if (base === 'english') {
    name = level.startsWith('JSS') ? 'English Studies' : 'English Language';
  }
  return `${name} (${level})`;
};

export default {
  COLORS,
  USER_ROLES,
  CLASS_LEVELS,
  CLASS_NAMES,
  SUBSCRIPTION_STATUS,
  CONTENT_STATUS,
  PAYMENT_STATUS,
  COLLECTIONS,
  NOTIFICATION_AUDIENCES,
  AVAILABLE_SUBJECTS,
  ALL_AVAILABLE_SUBJECT_IDS,
  SUBJECT_NAMES,
  getSubjectClass,
  getSubjectName,
  formatSubject,
};

